var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"pc-card",style:('background-image: url(' + _vm.image + ')'),attrs:{"to":_vm.to}},[_c('h4',{staticClass:"pc-card__title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }